import { CallOverrides } from "ethers";
      /* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type OlympicsContractFunctions1 =
  | []
  | [OlympicsContractFunctions]
  | [OlympicsContractFunctions, OlympicsContractEvents];
export type SWEvent = {
  event: OlympicsContractEventType;
  args: any;
}[];

export interface OlympicsContractFunctions {
  checkpointsAddress: (overrides?: CallOverrides) => Promise<string>;
  community: (overrides?: CallOverrides) => Promise<string>;
  createCompetition: (
    role: number,
    skill1: number,
    skill2: number,
    skill3: number,
    metadata: string,
    startTime: number,
    endTime: number,
    overrides?: CallOverrides
  ) => Promise<{wait: () => Promise<OlympicsContractEvents>}>;
  getCompetitions: (overrides?: CallOverrides) => Promise<string[]>;
  migratedFrom: (overrides?: CallOverrides) => Promise<string>;
  migratedTo: (overrides?: CallOverrides) => Promise<string>;
  version: (overrides?: CallOverrides) => Promise<number>;
}
export interface OlympicsContractEvents {
  events: SWEvent;
}

export enum OlympicsContractEventType {
  CompetitionCreated = "CompetitionCreated"
}
